import { Injectable } from '@angular/core';
import { AttributeSelectorServiceBase } from 'src/shared/services/attribute-selector-service-base';

@Injectable({
    providedIn: 'root'
})
export class AttributeSelectorService extends AttributeSelectorServiceBase {
    constructor() {
        super(true);
    }
}
